"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfResetAssessmentsDto = instanceOfResetAssessmentsDto;
exports.ResetAssessmentsDtoFromJSON = ResetAssessmentsDtoFromJSON;
exports.ResetAssessmentsDtoFromJSONTyped = ResetAssessmentsDtoFromJSONTyped;
exports.ResetAssessmentsDtoToJSON = ResetAssessmentsDtoToJSON;
exports.ResetAssessmentsDtoToJSONTyped = ResetAssessmentsDtoToJSONTyped;
/**
 * Check if a given object implements the ResetAssessmentsDto interface.
 */
function instanceOfResetAssessmentsDto(value) {
    if (!('assessmentIds' in value) || value['assessmentIds'] === undefined)
        return false;
    return true;
}
function ResetAssessmentsDtoFromJSON(json) {
    return ResetAssessmentsDtoFromJSONTyped(json, false);
}
function ResetAssessmentsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assessmentIds': json['assessmentIds'],
    };
}
function ResetAssessmentsDtoToJSON(json) {
    return ResetAssessmentsDtoToJSONTyped(json, false);
}
function ResetAssessmentsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'assessmentIds': value['assessmentIds'],
    };
}
//# sourceMappingURL=ResetAssessmentsDto.js.map